/*
 * forms.js  -  sends website forms to your inbox via Web3Forms
 * Location: frontend/src/lib/forms.js
 *
 * To change which inbox receives messages, create a new access key at
 * web3forms.com with that email address and paste it below.
 */
export const WEB3FORMS_KEY = "26521590-af8e-40bd-aa8e-e0d99faec577";

export async function sendForm(fields) {
  const res = await fetch("https://api.web3forms.com/submit", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ access_key: WEB3FORMS_KEY, ...fields }),
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* non-JSON response */
  }
  if (!res.ok || !data.success) {
    throw new Error(data.message || "Form submission failed");
  }
  return data;
}
